/* eslint-disable max-len */
import React, { useEffect, useCallback } from 'react';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Page, FilesDropzone, Header, Alert } from 'components';
import { enqueueSnackbar } from 'actions';
import { Button, Card, CardHeader, CardContent, CardActions, Grid, Divider, TextField, Accordion, AccordionSummary, AccordionDetails, Typography, colors } from '@mui/material';
import { RunFileUpload } from '../../actions/RETFilesUploadActions.js';
import DumpsDataTable from './RETFilesUploadHistory';
import MediaCard from './RETCard';
import { LastDumpsUpdate } from '../../actions/RetAuditActions';

const useStyles = makeStyles(theme => ({
	root: {
		padding: theme.spacing(3)
	},
	container: {
		marginTop: theme.spacing(3)
	},
	tabs: {
		marginTop: theme.spacing(3)
	},
	content: {
		marginTop: theme.spacing(3)
	},
	paper: {
		padding: theme.spacing(1)
	},
	popover: {
		pointerEvents: 'none'
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900]
		}
	}
}));

const RETFilesUpload = () => {
	const classes = useStyles();
	const dispatch = useDispatch();

	const user = useSelector(state => state.session.user);
	const dumps = useSelector(state => state.configurationReducer.dumps);

	const _getData = useCallback(() => {
		dispatch(LastDumpsUpdate());
	}, []);

	useEffect(() => {
		_getData();
	}, []);

	const _RETFilesUpload = file => {
		file.forEach(element => {
			// eslint-disable-next-line max-len
			if (!element.name.includes('Nemesis_Antennas') && !element.name.includes('EE_3G_RET_Licences') && !element.name.includes('EE LTE RET Data') && !element.name.includes('Combined RET Report EE') && !element.name.includes('Combined MHA Report EE')) {
				dispatch(
					enqueueSnackbar({
						message: `File ${element.name} not valid. Please check file nomenclature.`,
						options: { variant: 'warning' }
					})
				);
			} else {
				const username = `${user.firstname} ${user.lastname}`;
				dispatch(RunFileUpload(element, username, user.id));
			}
		});
	};

	return (
		<Page className={classes.root}>
			<div className={clsx(classes.container)}>
				<Card className={classes.container}>
					<CardContent>
						<Typography gutterBottom variant="h3" component="div">
							RET Enabling Checks
						</Typography>
						<br />
						<Grid container spacing={1}>
							<Grid item md={12} xs={12}>
								<MediaCard />
								<br />
								<FilesDropzone upload={_RETFilesUpload} />
							</Grid>
						</Grid>
					</CardContent>
				</Card>
				<br />
				<Card>
					<CardContent>
						<Typography gutterBottom variant="h3" component="div">
							History
						</Typography>
						<br />
						<DumpsDataTable data={dumps} />
					</CardContent>
				</Card>
			</div>
		</Page>
	);
};

export default RETFilesUpload;
